import {
    Alert,
    Button, Checkbox, CircularProgress,
    Container,
    Divider, FormControl,
    FormControlLabel, FormGroup, FormHelperText,
    FormLabel,
    Grid, IconButton, Input,

    InputAdornment, InputLabel,
    Link, OutlinedInput,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {ChangeEvent, useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {CustomerInput, MutationManagementLoginMutationArgs, useCreateCustomerMutation} from "../generated/graphql";
import {useUserDataContext, useUserLoginContext} from "../Contexts/UserContext";
import {useSiteDataContext} from "../Contexts/SiteDataContext";
import {useBasketContext} from "../Contexts/BasketContext";

type CustomerInputFront = CustomerInput & {
//    email2?:string,
    password2?:string
};

const blankCustomer:CustomerInputFront = {
    city:'',
    password:'',
    country:'',
    title:'',
    zip:'',
    first_name:'',
    mobile:'',
    last_name:'',
    street:'',
    email:'',
//    email2:'',
    password2:'',
    communicationPreferences:0
};

const validateEmail = (email:string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

function isValidPostcode(p:string) {
    const postcodeRegEx = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/i;
    return postcodeRegEx.test(p);
}


function LoginPage() {
    const navigate = useNavigate();
    const [showPassword,setShowPassword] = useState(false);
    const [state,setState] = useState<CustomerInputFront>(blankCustomer);
    const user = useUserDataContext();
    const setUser = useUserLoginContext();
    const [createAccountResult,createAccount] = useCreateCustomerMutation();
    const siteData = useSiteDataContext();
    const page = siteData.pages.createAccount;
    const [error,setError] = useState('');
    const basket =useBasketContext();
    function handleClickShowPassword() {
        setShowPassword((v)=>!v);
    }
    function onChange(evt:ChangeEvent) {
        setState((oldState)=>{
            const target = evt.target as HTMLInputElement;
            const v = {...oldState};
            const name = target.name as keyof CustomerInputFront;
            v[name] = target.value;
            return v;
        });
    }
    useEffect(()=>{
        if(user) {
            navigate('/select-membership');
            return;
        }
    },[user])
    const [postCodeState,setPostcodeState] = useState({error:false,message:''});
    const passwordState= {error:false,message:''},
        password2State = {error:false,message:''},
        emailState = {error:false,message:''};
//        email2State = {error:false,message:''};
    if(state.password!='') {
        if(state.password!.length<8) {
            passwordState.message = 'Minimum length 8 characters';
            passwordState.error = true;
        } else {
            if (state.password != state.password2) {
                password2State.message = 'Passwords do not match';
                password2State.error = true;
            }
        }
/*        if(passwordState.color=='info' && password2State.color=='info') {
            password2State.color = 'success';
            passwordState.color = 'success';
        }*/
    }
    if(state.email!='') {
        if(!validateEmail(state.email??'')) {
            emailState.message = page.errorEmail;
            emailState.error = true;
        } else {
/*            if (state.email != state.email2) {
                email2State.message = 'Email addresses do not match';
                email2State.error = true;
            }*/
        }
        /*if(emailState.color=='info' && email2State.color=='info') {
            email2State.color = 'success';
            emailState.color = 'success';
        }*/
    }
    function validatePostcode(onlyValid=false) {
        if(!isValidPostcode(state.zip??'')) {
            if(onlyValid) return;
            setPostcodeState({
                message: page.errorPostcode,
                error: true
            });
        } else {
            setPostcodeState({message:'',error:false});
        }
    }
    useEffect(()=> {
        validatePostcode(true);
    },[state.zip]);
    let isValid = true;
    Object.entries(state).forEach(([k,v])=>{
        switch(k) {
            case 'country':
                return;
            case 'communicationPreferences':
                return;
            default:
                if(v=='') {
                    isValid = false;
                }
            break;
        }
        return;
    });
    if(emailState.error||passwordState.error) {
        isValid = false;
    }
    async function submit() {
        setError('');
        const stateCopy = {...state};
//        delete stateCopy?.email2;
        delete stateCopy?.password2;
        const result = await createAccount({customer:stateCopy});
        const customerResult = result?.data?.createCustomer;
        if(!customerResult) {
            setError('Unable to create account');
            return;
        }
        if(customerResult.error) {
            setError(customerResult.error);
            return;
        }
        setUser(customerResult);
        basket.setCustomer(customerResult.customer);
    }
    const onChangeCheckBox = (value:number)=>()=>{
        setState((v)=>{
            const newV = {...v};
            const pref = v.communicationPreferences as number;
            if(pref & value) {
                newV.communicationPreferences = pref ^ value;
            } else {
                newV.communicationPreferences = pref | value;
            }
            return newV;
        })
    }
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{page.title}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(4)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                {!!error &&
                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{error}</Alert>
                }
                <form autoComplete="on">
                <TextField required label="Title" autoComplete="honorific-prefix" name="title" onChange={onChange} value={state.title} fullWidth={true} variant="standard"/>
                <TextField required label="First Name" name="first_name" onChange={onChange} value={state.first_name} fullWidth={true} variant="standard"/>
                <TextField required label="Last Name" name="last_name" onChange={onChange} value={state.last_name} fullWidth={true} variant="standard"/>
                <TextField required label="Mobile Phone" name="mobile" onChange={onChange} value={state.mobile} type="tel" fullWidth={true} variant="standard"/>
                <TextField required label="Address1" name="street" onChange={onChange} value={state.street} fullWidth={true} variant="standard"/>
                <TextField required label="City" name="city" onChange={onChange} value={state.city} fullWidth={true} variant="standard"/>
                <TextField label="Country" name="country" onChange={onChange} value={state.country} fullWidth={true} variant="standard"/>
                <TextField required error={postCodeState.error} helperText={postCodeState.message} autoComplete="postal-code" label="Postcode" name="zip" type="email" onChange={onChange} value={state.zip} onBlur={()=>{validatePostcode(false)}} fullWidth={true} variant="standard"/>
                <TextField required label="Email Address" name="email" type="email" onChange={onChange} value={state.email} fullWidth={true} variant="standard"
                error={emailState.error} helperText={emailState.message}/>
                    {/* <TextField required label="Email Address (repeat)" name="email2" onChange={onChange} value={state.email2} fullWidth={true} variant="standard"
                error={email2State.error} helperText={email2State.message}/> */ }
                <input type="hidden" name="username" value={state.email??''}/>
                <FormControl required fullWidth={true} variant="standard" margin="dense"  error={passwordState.error}>
                    <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                    <Input fullWidth={true}
                    value={state.password}
                    name="password"
                           autoComplete="new-password"
                    onChange={onChange}
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    {!!passwordState.message &&
                        <FormHelperText>{passwordState.message}</FormHelperText>
                    }
                </FormControl>
                <FormControl required fullWidth={true} variant="standard" margin="dense" error={password2State.error}>
                    <InputLabel htmlFor="outlined-adornment-password">Password (repeat)</InputLabel>
                    <Input fullWidth={true}
                    value={state.password2}
                    name="password2"
                           autoComplete="new-password"
                    onChange={onChange}
                        id="outlined-adornment-password"
                        type={showPassword ? 'text' : 'password'}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    {!!password2State.message &&
                      <FormHelperText>{password2State.message}</FormHelperText>
                    }
                </FormControl>
                <FormGroup sx={(theme)=>({marginTop:theme.spacing(2)})}>
                <InputLabel sx={(theme)=>({marginBottom:theme.spacing(1)})} shrink={true}>{page.marketingTitle}</InputLabel>
                    <Typography typography="p">{page.marketingSubtitle}</Typography>
                <FormControlLabel control={<Checkbox checked={!!(state.communicationPreferences!&1)}
                onChange={onChangeCheckBox(1)} />} label={page.marketingEmail}/>
                <FormControlLabel control={<Checkbox checked={!!(state.communicationPreferences!&2)}
                onChange={onChangeCheckBox(2)}/>} label={page.marketingPhone}/>
                <FormControlLabel control={<Checkbox checked={!!(state.communicationPreferences!&4)}
                                                     onChange={onChangeCheckBox(4)} />} label={page.marketingPost}
                />
                </FormGroup>
                <Button disabled={!isValid||createAccountResult.fetching} color="secondary" fullWidth={true} onClick={submit} sx={(theme)=>({marginTop:theme.spacing(4),marginBottom:theme.spacing(3)})} variant="contained" size="large"
                        startIcon={createAccountResult.fetching?<CircularProgress size="1rem"/>:null}
                >Continue</Button>
                <Typography typography="body2" sx={(theme)=>({marginBottom:theme.spacing(20)})}>
                    {page.privacyTextPre} <Link href={siteData?.siteData?.siteUrl+'privacy'}>{page.privacyLink}</Link>{page.privacyTextPost}
                </Typography>
                </form>
            </Grid>
        </Grid>
    </Container>);
}
export default LoginPage;